/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";

// No container border or shadow: the cards draw the frame so a short last row closes at its own width.
export const cardsContainerStyles = (theme, narrowColumnCount, wideColumnCount) => ({
  display: "grid",
  gridTemplateColumns: `repeat(${narrowColumnCount}, minmax(0, 1fr))`,
  margin: "20px 0px",

  [theme.breakpoints.up(1000)]: {
    gridTemplateColumns: `repeat(${wideColumnCount}, minmax(0, 1fr))`,
  },
});

export const CardFormula = styled("div")({
  marginTop: "8px",
  paddingTop: "8px",
  borderTop: "1px solid #eee",
  fontSize: "13px",
  fontWeight: "500",
  color: "#71717A",
});
